import React from 'react';
import PropTypes from 'prop-types';

import { ButtonFieldNew } from '../../../02_molecules/ButtonField';
import { PTButtonField } from '../../../02_molecules/ButtonField/prop-types';
import FormattedText from '../../../01_atoms/FormattedText';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

class BBMoneyHandlesNew extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
    };
  }

  render() {
    const { title, items, onSubmit, blockType, behaviorSettings, uuid } = this.props;
    const { isLoading } = this.state;

    const classes = [
      'bb',
      'bb-money-handles-new',
      styles['bb-money-handles-new'],
      generateClassNameByBehaviorSettings(behaviorSettings),
    ];

    return (
      <div className={classes.join(' ')} id={uuid}>
        <div className="container">
          {title && <FormattedText tag="h2" className="rockitt title" text={title} />}

          <div
            className={`d-lg-flex justify-content-${
              blockType === 'standalone_money_handles' ? 'between' : 'around'
            }`}
          >
            {items.map((item, index) => (
              <ButtonFieldNew
                key={item.value}
                {...item}
                position={index + 1}
                isDisabled={isLoading}
                buttonClassName="bb-money-handles-new--button"
                onSubmit={({ value, currency, position }) => {
                  // inject own loading routing as part of the Promise chain
                  this.setState({ isLoading: true });

                  return onSubmit({ value, currency, position }).then(() =>
                    this.setState({ isLoading: false }),
                  );
                }}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

BBMoneyHandlesNew.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape(PTButtonField)).isRequired,
  onSubmit: PropTypes.func.isRequired,
  blockType: PropTypes.string.isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};
BBMoneyHandlesNew.defaultProps = {
  title: null,
  behaviorSettings: null,
  uuid: null,
};

export default BBMoneyHandlesNew;
